import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { routesConfig } from './appRoutes';

function App() {
  return (
    <Router>
      <Routes>
        {routesConfig.map(({ path, element: Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
